<template>
    <div class="modal-mask" ref="root"
         :style="modalMaskStyle">
      <div class="modal-wrapper">
        <div class="modal-container" ref="el"
             :style="modalContainerStyle">
          <div class="layer-wrap" style="border: 0px;">
            <div class="layer-header"
                 v-if="isHeader">
              <span class="bold">{{ header }}</span>
              <button class="f-right"
                      v-if="isClose"
                      style="line-height: 36px;"
                      @click="btnClose_click()">
                <div class="img-com __del01">
                  <span>닫기</span>
                </div>
              </button>
            </div>
            <div class="layer-content"
                 :style="contentStyle">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script setup>
import {onMounted, defineProps, ref, defineEmits} from 'vue';
import {useDraggable} from "@vueuse/core";

const emits = defineEmits(['close']);

const props = defineProps({
  popupOpts: {
    type: Object,
  },
});

const isHeader = ref(true);
const header = ref('');
const isClose = ref(true);
const modalMaskStyle = ref({});
const modalContainerStyle = ref({});
const contentStyle = ref({});

const el = ref(null);

const initPopupOpts = () => {
  const {popupOpts} = props;

  if (popupOpts.isHeader) isHeader.value = popupOpts.isHeader;
  if (popupOpts.header) header.value = popupOpts.header;
  if (popupOpts.isClose != null) isClose.value = popupOpts.isClose;
  if (popupOpts.modalMaskStyle) modalMaskStyle.value = popupOpts.modalMaskStyle;
  if (popupOpts.contentStyle) contentStyle.value = popupOpts.contentStyle;
  if (popupOpts.modalContainerStyle) {
    popupOpts.modalContainerStyle.position = 'absolute';
    modalContainerStyle.value = popupOpts.modalContainerStyle;
  }
}

const btnClose_click = () => {
  emits('close');
 }

onMounted( () => {
  useDraggable(el); // 드래그만 적용
  initPopupOpts();
});

</script>

<style scoped>
.modal-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  /*max-width: 1280px;*/
  margin: 0px auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  /*display: table;*/
  /*overflow: hidden;*/
}

.layer-wrap {
  border: 1px solid #e0e0e0;
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.layer-wrap .layer-header {
  padding: 0 14px;
  height: 35px;
  line-height: 36px;
  font-size: 16px;
}

.layer-wrap .layer-content {
  border-top: 1px solid #e0e0e0;
  padding: 10px 14px;
}
</style>
